export class Page {

  constructor(public pageNumber: number, public imageIcon: string) {}

}
